import { useNavigate } from "react-router-dom";
import { ListPage } from "../components/ListPage";
import { useApp } from "../lib/store";
import { fmtEur } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { Lock } from "lucide-react";
import { trackRecent } from "../components/Layout";

const ABC = { A: "bg-emerald-100 text-emerald-800", B: "bg-blue-50 text-blue-700", C: "bg-slate-100 text-slate-600" };
const STATUS = { Active: "bg-emerald-50 text-emerald-700", Dormant: "bg-amber-50 text-amber-700", Blocked: "bg-red-50 text-red-600" };

const accSegments = (r) => (Array.isArray(r.segments) && r.segments.length ? r.segments : (r.segment ? [r.segment] : []));

export default function Accounts() {
  const { t, picklists, plLabel } = useApp();
  const navigate = useNavigate();
  const columns = [
    { key: "name", label: t("name"), render: (r) => (
      <span className="font-medium text-[#1B2A4A] flex items-center gap-1.5">
        {r.name}
        {r._restricted && <span title={t("restricted_account")} data-testid="restricted-badge"><Lock className="h-3 w-3 text-amber-500" /></span>}
      </span>
    ) },
    { key: "account_number", label: "#", render: (r) => <span className="font-mono text-xs">{r.account_number}</span> },
    { key: "type", label: t("type"), picklist: "account_types" },
    { key: "segments", label: t("segments"), render: (r) => {
      const segs = accSegments(r);
      return segs.length ? (
        <div className="flex flex-wrap gap-1">
          {segs.map((s) => <Badge key={s} className="bg-amber-50 text-amber-800 hover:bg-inherit font-normal" data-testid="account-segment-badge">{s}</Badge>)}
        </div>
      ) : <span className="text-gray-300">–</span>;
    } },
    { key: "abc_class", label: "ABC", render: (r) => <Badge className={`${ABC[r.abc_class] || ""} hover:bg-inherit`}>{r.abc_class}</Badge> },
    { key: "status", label: t("status"), render: (r) => <Badge className={`${STATUS[r.status] || ""} hover:bg-inherit`}>{plLabel("account_statuses", r.status)}</Badge> },
    { key: "annual_spend", label: t("annual_spend"), align: "right", render: (r) => fmtEur(r.annual_spend) },
    { key: "health_score", label: t("health_score"), align: "right", render: (r) => (
      r.health_score == null ? <span className="text-gray-300">–</span> : (
        <Badge data-testid="health-badge" className={`font-mono hover:bg-inherit ${r.health_score >= 75 ? "bg-emerald-100 text-emerald-700" : r.health_score >= 50 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700"}`}>
          {r.health_score}
        </Badge>
      )) },
    { key: "owner_name", label: t("owner") },
    { key: "city", label: t("city") },
  ];
  const filters = [
    { key: "segments", label: t("segment"), options: picklists.segments || [], match: (r, v) => accSegments(r).includes(v) },
  ];
  return (
    <ListPage module="accounts" titleKey="accounts" columns={columns} filters={filters}
      onRowClick={(r) => { trackRecent(r.name, `/accounts/${r.id}`); navigate(`/accounts/${r.id}`); }} />
  );
}
